import React, {Component} from 'react'
import TopBar from './components/TopBar'
import NavBar from './components/NavBar'
import Footer from './components/Footer'
import {BrowserRouter, Route} from 'react-router-dom'
import Home from './routes/Home'
import WhoAreWe from './routes/WhoAreWe'
import Quality from './routes/Quality'
import Contact from './routes/Contact'
import Services from './routes/Services'

class App extends Component {
    render() {
        return (
            <div>
                <div className="hidden-header" style={{height: '112px'}}></div>
                <BrowserRouter>
                    <div>
                        <header className={'clearfix'}>
                            <TopBar/>
                            <Route path="/:active?" component={NavBar}/>
                        </header>
                        <Route exact path="/" component={Home}/>
                        <Route exact path="/about" component={WhoAreWe}/>
                        <Route exact path="/services" component={Services}/>
                        <Route exact path="/quality" component={Quality}/>
                        <Route exact path="/contact" component={Contact}/>
                    </div>
                </BrowserRouter>
                <Footer/>
            </div>
        )
    }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js